import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GetUser } from "store/slices/authSlice";
import { MailChimpSubscriptionApi } from "store/slices/salonSlice";
import { usermoduleListViewApi } from "../store/slices/usermoduleSlice";
import { OpenAddClientForm } from "../store/slices/clientSlice";
import { notificationCountApi } from "store/slices/notificationSlice";
import { OpenSmsRunOutAlerts } from "store/slices/calendarSlice";

// Module-level guards so remounting pages/drawers that call SalonModule()
// do not re-fire global bootstrap APIs on every open.
let lastAuthFetchKey = null;
let notificationCountFetched = false;
let mailchimpFetchedForSalon = null;

const SalonModule = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const usermodule = useSelector((state) => state.usermodule.isListView);
  const auth = useSelector((state) => state.auth);
  const currentUser = auth && auth.user;
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth?.user?.auth_key || !auth?.token) return;
    const key = `${auth.user.auth_key}|${auth.token}`;
    if (lastAuthFetchKey === key) return;
    lastAuthFetchKey = key;
    dispatch(GetUser()).unwrap().catch(() => {
      lastAuthFetchKey = null;
    });
  }, [dispatch, auth?.user?.auth_key, auth?.token]);

  if (currentUser && currentUser.role_id == 8 && ["/dashboard", "/staff", "/reports"].includes(location && location.pathname)) {
    navigate("/noaccess");
  }

  useEffect(() => {
    if (usermodule.length === 0) {
      dispatch(usermoduleListViewApi()).then((action) => {
        if (action.meta.requestStatus === "fulfilled") {
          //dispatch(salonpermission({ module_id: 6, permissonName: "list" }));
        }
      });
      dispatch(usermoduleListViewApi({ type: "staff_access" }));
    }
    if (!notificationCountFetched) {
      notificationCountFetched = true;
      dispatch(notificationCountApi());
    }
  }, [dispatch, location.pathname, usermodule.length]);

  useEffect(() => {
    dispatch(OpenAddClientForm(""));
    const salonId = currentUser && currentUser.salon && currentUser.salon.id ? currentUser.salon.id : "";
    if (salonId && mailchimpFetchedForSalon !== salonId) {
      mailchimpFetchedForSalon = salonId;
      dispatch(MailChimpSubscriptionApi({ id: salonId, salon_id: salonId }));
    }
  }, [dispatch, location.pathname, currentUser && currentUser.salon && currentUser.salon.id]);

  useEffect(() => {
    if (!currentUser?.salon?.id || currentUser.salon.is_empty_sms_alert != 1) {
      return undefined;
    }

    const minutesRaw = currentUser?.sms_runout_reminder_minutes;
    const minutesParsed = parseInt(minutesRaw, 10);
    const minutes =
      Number.isFinite(minutesParsed) && minutesParsed >= 1 && minutesParsed <= 1440 ? minutesParsed : 15;
    const smsRunoutReminderMs = minutes * 60 * 1000;

    dispatch(OpenSmsRunOutAlerts("open"));

    const intervalId = setInterval(() => {
      dispatch(GetUser()).then((action) => {
        if (action.meta.requestStatus !== "fulfilled" || !action.payload) {
          return;
        }
        const user = action.payload;
        if (user?.salon?.is_empty_sms_alert == 1) {
          dispatch(OpenSmsRunOutAlerts("open"));
        } else {
          dispatch(OpenSmsRunOutAlerts(""));
        }
      });
    }, smsRunoutReminderMs);

    return () => clearInterval(intervalId);
  }, [dispatch, currentUser?.salon?.id, currentUser?.salon?.is_empty_sms_alert, currentUser?.sms_runout_reminder_minutes]);

  useEffect(() => {
    if (!currentUser?.salon) {
      return;
    }
    if (currentUser.salon.is_empty_sms_alert != 1) {
      dispatch(OpenSmsRunOutAlerts(""));
    }
  }, [dispatch, currentUser?.salon?.id, currentUser?.salon?.is_empty_sms_alert]);
};

export { SalonModule };
